import { apiClient } from '@shared/utils/api-client';

export interface MarketplaceSettings {
    sellerCommissionPercent: number;
    acquiringPercent: number;
    sellerCancellationPenaltyRub: number;
    sellerRefundPenaltyRub: number;
    sellerCancelStrikesToBlock: number;
    rankingWeightCpc: number;
    rankingWeightOrders: number;
    rankingWeightRating: number;
    rankingWeightNew: number;
    rankingProximityBlend: number;
    noveltyDaysThreshold: number;
    cpcClicksPerBillingUnit: number;
    sellerAdvertisingCreditLimitRub: number;
    cpcMaxBidRub: number;
    cpcMinBidRub: number;
    cpcClickDedupMinutes: number;
    updatedAt: string;
}

export interface MarketplaceSettingsPatch {
    sellerCommissionPercent: number;
    acquiringPercent: number;
    sellerCancellationPenaltyRub: number;
    sellerRefundPenaltyRub: number;
    sellerCancelStrikesToBlock: number;
    rankingWeightCpc: number;
    rankingWeightOrders: number;
    rankingWeightRating: number;
    rankingWeightNew: number;
    rankingProximityBlend: number;
    noveltyDaysThreshold: number;
    cpcClicksPerBillingUnit: number;
    sellerAdvertisingCreditLimitRub?: number;
    cpcMaxBidRub: number;
    cpcMinBidRub: number;
    cpcClickDedupMinutes: number;
}

export const marketplaceSettingsApi = {
    get: () => apiClient.get<MarketplaceSettings>('/marketplace-settings'),
    patch: (body: MarketplaceSettingsPatch) =>
        apiClient.patch<MarketplaceSettings>('/marketplace-settings', body),
};
